import React from "react";
import { Link } from "react-router";
import { IconButton, FlatButton, RaisedButton, Badge } from "material-ui";

import LocalMoviesIcon from "material-ui/svg-icons/maps/local-movies";
import ShoppingCartIcon from "material-ui/svg-icons/action/shopping-cart";

import { capitalize } from "../../util";

import connectToStores from "alt-utils/lib/connectToStores";
import PersonStore from "../../stores/PersonStore";
import PersonActions from "../../actions/PersonActions";
import CreditStore from "../../stores/CreditStore";
import CreditActions from "../../actions/CreditActions";
import OrderStore from "../../stores/OrderStore";

@connectToStores
class AccountAppBarItem extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hasFetchedCredits: false
    };
  }

  static getStores() {
    return [PersonStore, CreditStore, OrderStore];
  }

  static getPropsFromStores() {
    return {
      isLoggedIn: PersonStore.getState().isLoggedIn,
      credits: CreditStore.getState().credits
    };
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  componentWillReceiveProps(props) {
    if (
      this.context.appSettings &&
      this.context.appSettings.credits_enabled &&
      !this.state.hasFetchedCredits &&
      props.isLoggedIn
    ) {
      this.setState({ hasFetchedCredits: true });
      CreditActions.fetchCredits.defer();
    }
  }

  getStyles({ iconColor }) {
    return {
      creditOuter: {
        border: `2px solid ${iconColor}`,
        fontSize: 20,
        width: 20,
        height: 20,
        borderRadius: "100%",
        fontWeight: "bold",
        textAlign: "center"
      },
      creditInner: {
        fontSize: 14,
        verticalAlign: 5,
        color: iconColor
      }
    };
  }

  render() {
    let { openInNewTab } = this.props,
      iconColor = this.context.tenant.invert_colors_alt ? "#000" : "#fff",
      styles = this.getStyles({ iconColor });

    const ButtonComponent = this.context.tenant.invert_colors_alt
      ? RaisedButton
      : FlatButton;

    const cartQuantity = OrderStore.getCartQuantity();
    const cart = cartQuantity ? (
      <Link to="/schedule/checkout">
        <Badge
          badgeContent={cartQuantity}
          style={{ padding: 0 }}
          badgeStyle={{
            border: `1px solid ${this.context.muiTheme.rawTheme.palette.primary1Color}`,
            transform: "scale(0.8)"
          }}
        >
          <IconButton
            iconStyle={{
              transform: "scale(1.2)",
              verticalAlign: this.props.isLoggedIn ? -1 : -10,
              marginRight: !this.props.isLoggedIn && 5
            }}
            tooltip="Cart"
          >
            <ShoppingCartIcon color={iconColor} />
          </IconButton>
        </Badge>
      </Link>
    ) : null;

    if (!this.props.isLoggedIn) {
      return (
        <span>
          {/*!this.props.compact && this.context.tenant.additional_routes.length ?
            <Link to={this.context.tenant.additional_routes[0].name}><FlatButton label={this.context.tenant.additional_routes[0].display_short_name} style={{marginTop: 3, minWidth: 64, marginRight: 7}} /></Link>
          : null*/}
          <Link to={{ pathname: "/login", query: { next: "back" } }}>
            <ButtonComponent
              primary={this.context.tenant.invert_colors_alt}
              style={{
                marginTop: 3,
                minWidth: 64,
                fontWeight: 700,
                fontSize: "14px",
                marginRight: this.props.compact && -6
              }}
              buttonStyle={{
                color: this.context.tenant.invert_colors_alt
                  ? "#fff"
                  : undefined
              }}
            >
              LOGIN
            </ButtonComponent>
          </Link>
        </span>
      );
    } else {
      return (
        <div style={{ marginRight: -12 }}>
          {cart}
          {!this.props.compact ? (
            <span>
              {/*this.context.tenant.additional_routes.length ?
                <Link to={this.context.tenant.additional_routes[0].path}><IconButton iconStyle={{color: iconColor}} iconClassName="icon-info" tooltip={this.context.tenant.additional_routes[0].display_short_name} /></Link>
              : null*/}
              {this.context.tenant.menu_show_schedule ? (
                <Link to="/schedule" target={openInNewTab && "_blank"}>
                  <IconButton
                    iconStyle={{ color: iconColor }}
                    iconClassName="icon-calendar"
                    tooltip={capitalize(this.context.tenant.display_schedule)}
                  />
                </Link>
              ) : null}
              {this.context.tenant.menu_show_film_guide &&
              this.context.appSettings.film_guide_enabled ? (
                <Link to="/films" target={openInNewTab && "_blank"}>
                  <IconButton
                    tooltip={capitalize(
                      this.context.tenant.display_film_guide || "Film guide"
                    )}
                    iconStyle={{ transform: "scale(1.31)", verticalAlign: -2 }}
                  >
                    <LocalMoviesIcon color={iconColor} />
                  </IconButton>
                </Link>
              ) : null}
              {this.context.appSettings.credits_enabled ? (
                <Link to="/credits" target={openInNewTab && "_blank"}>
                  <IconButton
                    tooltip={`${
                      this.props.credits === null
                        ? "Loading"
                        : this.props.credits
                    } credits`}
                  >
                    <div>
                      <div style={styles.creditOuter}>
                        <span style={styles.creditInner}>
                          {this.props.credits === null
                            ? "..."
                            : this.props.credits}
                        </span>
                      </div>
                    </div>
                  </IconButton>
                </Link>
              ) : null}
              {this.context.tenant.passes_enabled ? (
                <Link
                  to={`/${this.context.tenant.passes_url_pathname}`}
                  target={openInNewTab && "_blank"}
                >
                  <IconButton
                    iconStyle={{ color: iconColor }}
                    iconClassName="icon-profile"
                    tooltip={`My ${this.context.tenant.display_passes}`}
                  />
                </Link>
              ) : null}
              {this.context.tenant.memberships_enabled ? (
                <Link
                  to={`/${this.context.tenant.memberships_url_pathname}`}
                  target={openInNewTab && "_blank"}
                >
                  <IconButton
                    iconStyle={{ color: iconColor }}
                    iconClassName="icomoon icon-qrcode"
                    tooltip={`My ${this.context.tenant.display_memberships}`}
                  />
                </Link>
              ) : null}
            </span>
          ) : null}
          {this.context.tenant.menu_show_my_tickets ? (
            <Link to="/tickets" target={openInNewTab && "_blank"}>
              <IconButton
                iconStyle={{ color: iconColor }}
                iconClassName="icon-ticket"
                tooltip="My tickets"
              />
            </Link>
          ) : null}
          <IconButton
            iconStyle={{ color: iconColor }}
            iconClassName="icon-exit"
            onClick={() => PersonActions.logout()}
            tooltip="Log out"
          />
        </div>
      );
    }
  }
}

export default AccountAppBarItem;



// WEBPACK FOOTER //
// ./src/app/components/partials/account-app-bar-item.jsx